// extracted by mini-css-extract-plugin
export default {"content":"layout-module_content-ItCCI","content--dark":"layout-module_content--dark-qW8wZ"};